module.exports = __webpack_public_path__ + "img/img_avatar1.e3ed9a74.png";